export const outstanding_only_filter_form = {
  outstanding_only: "Outstanding only",
};
